<template>
  <div class="cloud-resource">
    <div class="main">
      <!-- 左边导航 -->
      <div id='cloud-resource-nav-bar' class="nav-bar">
        <SyncNavBarList @selectOption='selectOption' />
      </div>

      <!-- 右边展示内容 -->
      <div class="main-view">
        <!-- 内容顶部类型导航 -->
        <div class="type-nav">
          <SyncTypeNavBar @selectRtype='selectRtype' />
        </div>

        <!-- 内容展示 -->
        <div class="content-list">
          <SyncResourceList :loading='loading' v-loading="loading" element-loading-spinner="el-icon-loading"
            element-loading-text="拼命加载中" :syncResource='syncResource' />

          <!-- 页码 -->
          <div class="page-num">
            <PageNum :pageTotal='pageTotal' :currentPage1.sync='currentPage' />
          </div>

        </div>
      </div>

    </div>
  </div>
</template>

<script>
//api获取--------------------------------------------
import { getChapterTree, getResource } from "@/network/resourceRequest/api";

//左边导航
import SyncNavBarList from "@/views/resourceCenter/components/syncTextBookResource/components/SyncNavBarList";
//顶部导航
import SyncTypeNavBar from "@/views/resourceCenter/components/syncTextBookResource/components/SyncTypeNavBar";
//内容导航--------------------------------------------
import SyncResourceList from "@/views/resourceCenter/components/syncTextBookResource/components/SyncResourceList";
//页面导航--------------------------------------------
import PageNum from "@/components/common/PageNum";

export default {
  name: "SyncTextBook",
  components: {
    SyncNavBarList,
    SyncTypeNavBar,
    SyncResourceList,
    PageNum,
  },
  data() {
    return {
      //筛选的条件
      fd: {},
      //当前页码--------------------------------------------
      currentPage: 1,
      //页码总数量
      pageTotal: 0,

      //渲染的数据
      syncResource: {},

      //是否存在章节
      isChapter: false,

      //是否显示加载--------------------------------------------
      loading: false,
    };
  },

  watch: {
    //页码筛选
    currentPage(newVal) {
      this.fd.pageNum = newVal;
      this.getSelectResource(this.fd, "pageNum");
    },
  },

  created() {
    this.getSelectResource(this.fd);
  },

  methods: {
    //侧边筛选数据
    selectOption(option) {
      this.fd.chapterId && delete this.fd.chapterId;
      if (option.chapterId) {
        this.$set(this.fd, "chapterId", option.chapterId);
        this.getSelectResource(this.fd);
      }
    },

    //rtype筛选
    selectRtype(option) {
      if (option == "全部") {
        this.$delete(this.fd, "type");
      } else {
        this.$set(this.fd, "type", option);
      }
      this.getSelectResource(this.fd);
    },

    //根据条件获取数据
    //获取选中条件的试卷
    getSelectResource(fd, type) {
      if (type != "pageNum") {
        //进行任何非页码筛选均改回第一页
        this.fd.pageNum = 1;
        this.currentPage = 1;
      }

      //进行任何非页码筛选均改回第一页
      this.fd.pageSize = 10;
      this.loading = true;
      getResource(fd).then(
        (res) => {
          if (res.data.success) {
            this.loading = false;
            this.syncResource = res.data.data ? res.data.data : {};
            this.pageTotal = res.data.data ? Number(res.data.data.total) : 0;
          }
        },
        (err) => {
          console.log("getSelectResource -> err", err);
        }
      );
    },
  },
};
</script>

<style lang="less" scoped>
.cloud-resource {
  padding-top: 5px;

  .main {
    width: 1200px;
    min-height: 1200px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;

    // 左边导航
    .nav-bar {
      box-shadow: 0 0 5px 1px #ccc;
      border-radius: 5px;
      width: 235px;
      min-height: 500px;
      background-color: #fff;
    }

    //内容
    .main-view {
      box-shadow: 0 0 5px 1px #ccc;
      border-radius: 5px;
      overflow: hidden;
      width: 960px;
      min-height: 500px;
      background-color: #fff;

      .content-list {
        /deep/ .el-loading-spinner {
          top: 0 !important;
        }

        /deep/ .el-loading-spinner i {
          color: #24ba58 !important;
        }

        /deep/ .el-loading-spinner .el-loading-text {
          color: #24ba58 !important;
        }
        .page-num {
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 20px 0;
        }
      }
    }
  }
}
</style>